import React from 'react'

const GaleriaVazia = ({ classes }) => {
  return (
    <div className={classes.galeriaVazia}>
      <svg width="240" height="180" viewBox="0 0 220 160" fill="none">
        <rect x="20" y="30" width="180" height="110" rx="14" fill="#F3F6FF" />

        <circle cx="75" cy="70" r="10" fill="#9FB3E8" />

        <path d="M40 120L85 80L115 105L150 70L190 120" stroke="#7C96D6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />

        <rect x="85" y="15" width="50" height="28" rx="8" fill="#E4EBFF" />

        <circle cx="110" cy="29" r="5" fill="#7C96D6" />
      </svg>

      <span className={classes.textoVazio}>Nenhuma foto na galeria</span>
    </div>
  )
}

export default GaleriaVazia
